import { render, staticRenderFns } from "./SmileyFaceDashboardItem.vue?vue&type=template&id=3741a8af"
import script from "./SmileyFaceDashboardItem.vue?vue&type=script&lang=js"
export * from "./SmileyFaceDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3741a8af')) {
      api.createRecord('3741a8af', component.options)
    } else {
      api.reload('3741a8af', component.options)
    }
    module.hot.accept("./SmileyFaceDashboardItem.vue?vue&type=template&id=3741a8af", function () {
      api.rerender('3741a8af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/SmileyFaceDashboardItem.vue"
export default component.exports